import UserReviewBox from '@theme/components/content/UserReviewBox'

export default {
  name: 'UserReviews',
  components: { UserReviewBox },
  data() {
    return {
      items: Object.values(this.$t('UserReviews.items')),
      currentIndex: 0,
      windowWidth: null,
    }
  },
  computed: {
    responsiveItemsPerPage() {
      if (this.windowWidth >= 992) return 4
      if (this.windowWidth >= 768) return 2
      return 1
    },
    paginatedItems() {
      return this.items.slice(this.currentIndex, this.currentIndex + this.responsiveItemsPerPage)
    },
    hasNextPage() {
      return this.currentIndex + this.responsiveItemsPerPage < this.items.length
    },
    hasPrevPage() {
      return this.currentIndex > 0
    },
  },
  methods: {
    nextPage() {
      if (this.hasNextPage) {
        this.currentIndex++
      }
    },
    prevPage() {
      if (this.hasPrevPage) {
        this.currentIndex--
      }
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth
    },
  },
  mounted() {
    this.updateWindowWidth()
    window.addEventListener('resize', this.updateWindowWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth)
  },
}
